import Modal from 'react-modal';
import {atom,useAtom} from 'jotai';
import { Box, Circle, Flex,Heading } from '@chakra-ui/react';
import { IoIosCheckmarkCircleOutline as SuccessIcon } from "react-icons/io";
import { CiWarning as ErrorIcon } from "react-icons/ci";
import { useRef } from 'react';
const customStyles = {
    content: {
        backgroundColor:'transparent',
        padding:'0',
        width:'100%',
        margin:'0',
        display:'flex',
        justifyContent:'center',
        border:'none',
        height:'fit-content',
    },
    
    overlay:{
      backgroundColor:'transparent'
    }
  };

// Modal.setAppElement('#notification')
export const openNAtom = atom<boolean>(false);
export const notificationAtom = atom<any>({
    message:'Hello world',
    type:'success'
});
const NotificationContextProvider = (props:any) => {
    const contentRef = useRef<any>(null);
    const [show_modal,set_show_modal] = useAtom(openNAtom);
    const [{message='Hello world',type='success'}] = useAtom(notificationAtom);
  return (
    <>
        {props.children}
        <Modal
            
            isOpen={show_modal}
            style={customStyles}
            onAfterOpen={()=> {
                if(contentRef && contentRef.current){
                    contentRef.current.classList.add('animate-notification')
                }
                setTimeout(()=>{
                    if(contentRef && contentRef.current){
                        contentRef.current.classList.remove('animate-notification')
                    }
                    set_show_modal(false);
                },3000)}
            }
        >
            {
              <Box bg="transparent" ref={contentRef} sx={{position:'fixed',
                top:'-100vh',
                width:'100%',
                display:'flex',
                justifyContent:'center',
                left:0,}}>
                    <Flex align="center" gap="20px" padding="10px 30px" borderRadius="5px" bg={type==='success'?'rgb(10,100,10)':'rgb(185, 4, 4)'} color="var(--white-color)" fontWeight="500">
                       {type==='success'?<SuccessIcon/>:<ErrorIcon />} <span>{message}</span>
                    </Flex>

              </Box>
            }
        </Modal>
    </>
  )
}

export default NotificationContextProvider